import React from 'react';
import {Col, Row} from 'antd';
import InputField from '../../../../input-field';
import DividerBlock from "../../../../divider-block";
import i18n from "../../../../../i18n";

export default function AddressesFields({ stepFields, setFields, getFieldErrors, edit = false }) {
	    let dividerStyle = {
        margin: "15px 0px 45px 0px",
        display: "block",
        clear: "both",
        width: "100%",
        minWidth: "100%",
        height: "1px",
      };
    return (
      <>
        <span className="divider-label">{i18n.t('modals.modalCreateNewLegalEntity.divider.address')}</span>
        <DividerBlock style={dividerStyle} />
        <Row gutter={[12, 24]}>
          <Col lg={8} md={12} sm={24} xs={24} style={{ margin: "0 0 20px 0" }}>
            <InputField
              name="regRegion"
              label={i18n.t('modals.modalCreateNewLegalEntity.fields.legalRegion.title')}
              value={stepFields.regRegion}
              setValue={(value) =>
                setFields({ ...stepFields, regRegion: value })
              }
              getFieldErrors={getFieldErrors}
            />
          </Col>
          <Col lg={8} md={12} sm={24} xs={24} style={{ margin: "0 0 20px 0" }}>
            <InputField
              name="regLocality"
              label={i18n.t('modals.modalCreateNewLegalEntity.fields.legalLocality.title')}
              value={stepFields.regLocality}
              setValue={(value) =>
                setFields({ ...stepFields, regLocality: value })
              }
              getFieldErrors={getFieldErrors}
            />
          </Col>
          <Col lg={8} md={12} sm={24} xs={24} style={{ margin: "0 0 20px 0" }}>
            <InputField
              name="regStreet"
              label={i18n.t('modals.modalCreateNewLegalEntity.fields.legalStreet.title')}
              value={stepFields.regStreet}
              setValue={(value) =>
                setFields({ ...stepFields, regStreet: value })
              }
              getFieldErrors={getFieldErrors}
            />
          </Col>
          <Col lg={8} md={12} sm={24} xs={24} style={{ margin: "0 0 20px 0" }}>
            <InputField
              name="regHouseNumber"
              label={i18n.t('modals.modalCreateNewLegalEntity.fields.legalHouseNumber.title')}
              value={stepFields.regHouseNumber}
              setValue={(value) =>
                setFields({ ...stepFields, regHouseNumber: value })
              }
              getFieldErrors={getFieldErrors}
            />
          </Col>
          <Col lg={8} md={12} sm={24} xs={24} style={{ margin: "0 0 20px 0" }}>
            <InputField
              name="regPremiseNumber"
              label={i18n.t('modals.modalCreateNewLegalEntity.fields.legalPremiseNumber.title')}
              value={stepFields.regPremiseNumber}
              setValue={(value) =>
                setFields({ ...stepFields, regPremiseNumber: value })
              }
              getFieldErrors={getFieldErrors}
            />
          </Col>
          <Col lg={8} md={12} sm={24} xs={24} style={{ margin: "0 0 20px 0" }}>
            <InputField
              name="regPostalCode"
              label={i18n.t('modals.modalCreateNewLegalEntity.fields.legalAddressPostalCode.title')}
              value={stepFields.regPostalCode}
              setValue={(value) =>
                setFields({ ...stepFields, regPostalCode: value })
              }
              getFieldErrors={getFieldErrors}
            />
          </Col>
        </Row>

        <span className="divider-label">{i18n.t('modals.modalCreateNewLegalEntity.divider.postalAddress')}</span>
        <DividerBlock style={dividerStyle} />
        <Row gutter={[12, 24]}>
          <Col lg={8} md={12} sm={24} xs={24} style={{ margin: "0 0 20px 0" }}>
            <InputField
              name="mailingRegion"
              label={i18n.t('modals.modalCreateNewLegalEntity.fields.legalRegion.title')}
              value={stepFields.mailingRegion}
              setValue={(value) =>
                setFields({ ...stepFields, mailingRegion: value })
              }
              getFieldErrors={getFieldErrors}
            />
          </Col>
          <Col lg={8} md={12} sm={24} xs={24} style={{ margin: "0 0 20px 0" }}>
            <InputField
              name="mailingLocality"
              label={i18n.t('modals.modalCreateNewLegalEntity.fields.legalLocality.title')}
              value={stepFields.mailingLocality}
              setValue={(value) =>
                setFields({ ...stepFields, mailingLocality: value })
              }
              getFieldErrors={getFieldErrors}
            />
          </Col>
          <Col lg={8} md={12} sm={24} xs={24} style={{ margin: "0 0 20px 0" }}>
            <InputField
              name="mailingStreet"
              label={i18n.t('modals.modalCreateNewLegalEntity.fields.legalStreet.title')}
              value={stepFields.mailingStreet}
              setValue={(value) =>
                setFields({ ...stepFields, mailingStreet: value })
              }
              getFieldErrors={getFieldErrors}
            />
          </Col>
          <Col lg={8} md={12} sm={24} xs={24} style={{ margin: "0 0 20px 0" }}>
            <InputField
              name="mailingHouseNumber"
              label={i18n.t('modals.modalCreateNewLegalEntity.fields.legalHouseNumber.title')}
              value={stepFields.mailingHouseNumber}
              setValue={(value) =>
                setFields({ ...stepFields, mailingHouseNumber: value })
              }
              getFieldErrors={getFieldErrors}
            />
          </Col>
          <Col lg={8} md={12} sm={24} xs={24} style={{ margin: "0 0 20px 0" }}>
            <InputField
              name="mailingPremiseNumber"
              label={i18n.t('modals.modalCreateNewLegalEntity.fields.legalPremiseNumber.title')}
              value={stepFields.mailingPremiseNumber}
              setValue={(value) =>
                setFields({ ...stepFields, mailingPremiseNumber: value })
              }
              getFieldErrors={getFieldErrors}
            />
          </Col>
          <Col lg={8} md={12} sm={24} xs={24} style={{ margin: "0 0 20px 0" }}>
            <InputField
              name="mailingPostalCode"
              label={i18n.t('modals.modalCreateNewLegalEntity.fields.legalAddressPostalCode.title')}
              value={stepFields.mailingPostalCode}
              setValue={(value) =>
                setFields({ ...stepFields, mailingPostalCode: value })
              }
              getFieldErrors={getFieldErrors}
            />
          </Col>
        </Row>
      </>
    );
}
